import { render, staticRenderFns } from "./MarketCategoryForm.vue?vue&type=template&id=3e61c266"
import script from "./MarketCategoryForm.vue?vue&type=script&lang=js"
export * from "./MarketCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports